// Import model
import { SfProposal } from '../models/SfProposal';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for SfProposal - handles JSON serialization and deserialization with type validation
 */
export class SfProposalSerializer {
  /**
   * Deserializes a JSON string into a SfProposal instance
   */
  static deserialize(json: string): SfProposal {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a SfProposal instance
   */
  static fromObject(obj: any): SfProposal {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to SfProposal');
    }


    const instance: SfProposal = {
      externalId: obj['externalId'] as string | undefined,
      isDeleted: obj['isDeleted'] as boolean | undefined,
      name: obj['name'] as string | undefined,
      createdDate: obj['createdDate'] as string | undefined,
      projectExternalId: obj['projectExternalId'] as string | undefined,
      projectExternalIdName: obj['projectExternalId|Name'] as string | undefined,
      totalPrice: obj['totalPrice'] as number | undefined,
      totalCost: obj['totalCost'] as number | undefined,
      totalTax: obj['totalTax'] as number | undefined,
      proposalNumber: obj['proposalNumber'] as number | undefined,
      status: obj['status'] as string | undefined,
      customerExternalId: obj['customerExternalId'] as string | undefined,
      customerExternalIdName: obj['customerExternalId|Name'] as string | undefined,
      landedDate: obj['landedDate'] as string | undefined,
      producedDate: obj['producedDate'] as string | undefined,
      notes: obj['notes'] as string | undefined,
      leadingProducts: obj['leadingProducts'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of SfProposal instances
   */
  static deserializeArray(json: string): SfProposal[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a SfProposal instance to a JSON string
   */
  static serialize(instance: SfProposal): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a SfProposal instance to a plain object
   */
  static toObject(instance: SfProposal): any {
    return {
      'externalId': instance.externalId,
      'isDeleted': instance.isDeleted,
      'name': instance.name,
      'createdDate': instance.createdDate,
      'projectExternalId': instance.projectExternalId,
      'projectExternalId|Name': instance.projectExternalIdName,
      'totalPrice': instance.totalPrice,
      'totalCost': instance.totalCost,
      'totalTax': instance.totalTax,
      'proposalNumber': instance.proposalNumber,
      'status': instance.status,
      'customerExternalId': instance.customerExternalId,
      'customerExternalId|Name': instance.customerExternalIdName,
      'landedDate': instance.landedDate,
      'producedDate': instance.producedDate,
      'notes': instance.notes,
      'leadingProducts': instance.leadingProducts,
    };
  }

  /**
   * Serializes an array of SfProposal instances to a JSON string
   */
  static serializeArray(instances: SfProposal[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
